import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { motion } from 'framer-motion';
import { MdOutlineEmail, MdOutlineLocationOn, MdPhoneInTalk } from 'react-icons/md';
import { FaFacebookF, FaLinkedinIn, FaYoutube } from 'react-icons/fa';

import logo from '../../assets/logoblack.png';
import house3d from '../../assets/images/footer_house_3d.png';

import './Footer.css';

function Footer() {
  return (
    <footer className="footer-exact">
      
      {/* ── Footer CTA Banner ─────────────────────────── */}
      <div className="container">
        <motion.div 
          className="cta-banner"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="cta-banner__visual">
            <div className="cta-banner__glow" aria-hidden="true" />
            <img src={house3d} alt="3D Isometric House" />
          </div>
          <div className="cta-banner__content">
            <h2>Get in Touch with Our <br /> Roofing Experts Today</h2>
            <p>Ready to protect your home with a strong, reliable roof? <br /> Whether you're in need of a complete roof replacement.</p>
            <div className="cta-banner__buttons">
              <AnchorLink href="#Contact" className="btn btn-solid">START YOUR JOURNEY</AnchorLink>
              <AnchorLink href="#Contact" className="btn btn-outline">CONTACT US</AnchorLink>
            </div>
          </div>
        </motion.div>
      </div>

      {/* ── Footer Main Body ──────────────────────────── */}
      <div className="footer-body">
        <div className="container">
          <div className="footer-body__grid">
            
            {/* Column 1: Brand Identity */}
            <div className="footer-body__col footer-body__col--brand">
              <div className="footer-body__logo">
                <img src={logo} alt="RoofPro Logo" />
              </div>
              <p className="footer-body__about">
                We're committed to delivering top-quality roofing service that protect 
                your home & enhance it value. With years of expertise focus customer.
              </p>
              <div className="footer-body__contact">
                <div className="contact-line">
                  <MdPhoneInTalk /> <span>+1123 456 7890</span>
                </div>
                <div className="contact-line">
                  <MdOutlineLocationOn /> <span>421 Allen, RoofPro 4233</span>
                </div>
                <div className="contact-line">
                  <MdOutlineEmail /> <span>roofprohospital@com</span>
                </div>
              </div>
              <div className="footer-body__social">
                <a href="#" className="social-circle"><FaFacebookF /></a>
                <a href="#" className="social-circle"><FaLinkedinIn /></a>
                <a href="#" className="social-circle"><FaYoutube /></a>
              </div>
            </div>

            {/* Column 2: Top Links */}
            <div className="footer-body__col">
              <h4 className="footer-body__title">Top Links</h4>
              <ul className="footer-body__list">
                <li><AnchorLink href="#About">About US</AnchorLink></li>
                <li><AnchorLink href="#Products">Our Service</AnchorLink></li>
                <li><AnchorLink href="#Blog">Recent Blog</AnchorLink></li>
                <li><AnchorLink href="#Team">Our Team</AnchorLink></li>
                <li><AnchorLink href="#Contact">Contact Us</AnchorLink></li>
              </ul>
            </div>

            {/* Column 3: Our Services */}
            <div className="footer-body__col">
              <h4 className="footer-body__title">Our Services</h4>
              <ul className="footer-body__list">
                <li><AnchorLink href="#Products">Shield & Shine Roofing</AnchorLink></li>
                <li><AnchorLink href="#Products">Home Guard Roofing</AnchorLink></li>
                <li><AnchorLink href="#Products">Peak Protection</AnchorLink></li>
                <li><AnchorLink href="#Products">Roof Repair</AnchorLink></li>
                <li><AnchorLink href="#Products">Rain Proof Roofers</AnchorLink></li>
              </ul>
            </div>

            {/* Column 4: Working Hours */}
            <div className="footer-body__col">
              <h4 className="footer-body__title">Working Hours</h4>
              <div className="hours-card">
                <div className="hours-row">
                  <span className="hours-day">Mon-Wed</span>
                  <span className="hours-time">9:00 AM - 5:00 PM</span>
                </div>
                <div className="hours-row">
                  <span className="hours-day">Tue-Sat</span>
                  <span className="hours-time">4:00 PM - 9:00 PM</span>
                </div>
                <div className="hours-row hours-row--closed">
                  <span className="hours-day">Sunday</span>
                  <span className="hours-time">Close</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ── Footer Legal Bar ─────────────────────────── */}
      <div className="footer-legal">
        <div className="container footer-legal__inner">
          <p>Copyright @2026 <a href="https://www.solvyte.com" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Solvyte</a>. All Rights Reserved</p>
        </div>
      </div>

    </footer>
  );
}

export default Footer;